/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';

import {
  ModalCodeHeader,
  ModalCodeTitle,
  ModalCodeBody,
  ModalCodeContent,
  ModalCodeImageContainer,
  ModalCodeImage,
  ModalCodeSection,
  ModalCodeItem,
  ModalCodeItemImage,
} from './styles';

export default class FindYouCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalNdd: false,
      modalNfe: false,
      modalColetor1: false,
      modalColetor2: false,
    };
  }

  render() {
    return (
      <>
        <ModalCodeHeader closeButton>
          <ModalCodeTitle id="contained-modal-title-vcenter">
            Encontre seu código em sua nota fiscal. Veja os modelos abaixo:
          </ModalCodeTitle>
        </ModalCodeHeader>
        <ModalCodeBody>
          <ModalCodeContent>
            {this.state.modalNfe ? (
              <ModalCodeImageContainer
                onClick={() =>
                  this.setState({
                    modalNfe: false,
                    modalNdd: false,
                    modalColetor1: false,
                    modalColetor2: false,
                  })
                }
              >
                <ModalCodeImage src="./static/exemplo_nfe.png" />
              </ModalCodeImageContainer>
            ) : null}

            {this.state.modalNdd ? (
              <ModalCodeImageContainer
                onClick={() =>
                  this.setState({
                    modalNfe: false,
                    modalNdd: false,
                    modalColetor1: false,
                    modalColetor2: false,
                  })
                }
              >
                <ModalCodeImage src="./static/exemplo_ndd.png" />
              </ModalCodeImageContainer>
            ) : null}

            {this.state.modalColetor1 ? (
              <ModalCodeImageContainer
                onClick={() =>
                  this.setState({
                    modalNfe: false,
                    modalNdd: false,
                    modalColetor1: false,
                    modalColetor2: false,
                  })
                }
              >
                <ModalCodeImage src="./static/exemplo_coletor1.png" />
              </ModalCodeImageContainer>
            ) : null}

            {this.state.modalColetor2 ? (
              <ModalCodeImageContainer
                onClick={() =>
                  this.setState({
                    modalNfe: false,
                    modalNdd: false,
                    modalColetor1: false,
                    modalColetor2: false,
                  })
                }
              >
                <ModalCodeImage src="./static/exemplo_coletor2.png" />
              </ModalCodeImageContainer>
            ) : null}

            {this.state.modalNfe ||
            this.state.modalNdd ||
            this.state.modalColetor1 ||
            this.state.modalColetor2 ? null : (
              <ModalCodeSection>
                <ModalCodeItem>
                  <ModalCodeItemImage
                    onClick={() =>
                      this.setState({
                        modalNfe: true,
                        modalNdd: false,
                        modalColetor1: false,
                        modalColetor2: false,
                      })
                    }
                  >
                    <ModalCodeImage src="./static/exemplo_nfe.png" />
                  </ModalCodeItemImage>
                  <ModalCodeItemImage
                    onClick={() =>
                      this.setState({
                        modalNfe: false,
                        modalNdd: true,
                        modalColetor1: false,
                        modalColetor2: false,
                      })
                    }
                  >
                    <ModalCodeImage src="./static/exemplo_ndd.png" />
                  </ModalCodeItemImage>
                </ModalCodeItem>
                <ModalCodeItem className="mt-3">
                  <ModalCodeItemImage
                    onClick={() =>
                      this.setState({
                        modalNfe: false,
                        modalNdd: false,
                        modalColetor1: true,
                        modalColetor2: false,
                      })
                    }
                  >
                    <ModalCodeImage src="./static/exemplo_coletor1.png" />
                  </ModalCodeItemImage>
                  <ModalCodeItemImage
                    onClick={() =>
                      this.setState({
                        modalNfe: false,
                        modalNdd: false,
                        modalColetor1: false,
                        modalColetor2: true,
                      })
                    }
                  >
                    <ModalCodeImage src="./static/exemplo_coletor2.png" />
                  </ModalCodeItemImage>
                </ModalCodeItem>
              </ModalCodeSection>
            )}
          </ModalCodeContent>
        </ModalCodeBody>
      </>
    );
  }
}
